let showTableSessionDetails = null;

$(function () {
  let storageModalAjaxLock = false;
  let activeMode = 'products';
  let activeGuestId = null;
  let splitState = { sessionProductId: null, qty: 2, price: 0 };
  let activeSessionId = null;
  let selectedGuestId = null;
  let ajaxLockForModal = false;

  $(document).on('click', '#order-storage-modal', function () {
    if (hasBeenInactive) {
      showClearCartConfirmation();
      return;
    }
    if (locationCart.is_per_person_ordering_enabled) {
      $('#open-cart').trigger('click');
      return;
    }
    let products_in_cart = 0;

    if (
      locationCart.number_of_products !== undefined &&
      locationCart.number_of_products >= 0 &&
      !locationCart.table_number
    ) {
      products_in_cart = locationCart.number_of_products;
    }

    locationId = $(this).attr('data-location-id');
    if (!storageModalAjaxLock) {
      storageModalAjaxLock = true;
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/sessions',
        data: {
          organizer_id: organizerId,
          location_id: locationId,
          products_in_cart: locationCart.table_session_id
            ? 0
            : products_in_cart,
        },
      })
        .done(function (response) {
          const { data, message, status } = response;
          if (data.html !== undefined && data.html !== null) {
            if ($('#table-sessions-modal').length > 0) {
              $('#table-sessions-modal').remove();
            }

            $('#content-body').append(data.html);
            $('#table-sessions-modal')
              .on('hidden.bs.modal', function () {
                setTimeout(function () {
                  $('#table-sessions-modal').remove();
                }, 500);
              })
              .modal('show');

            $('.table-card')
              .filter(function () {
                return (
                  $(this).find('.table-card-content').data('session-id') ||
                  locationCart.products.length > 0
                );
              })
              .holdToConfirm({
                targetSelector: '.table-card-content',
                svgSelector: '.table-ring-svg',
                totalDuration: 1250,
                onStart: function ($wrap, $target) {
                  if (
                    $target.attr('data-has-enabled-per-person-ordering') ==
                      '1' &&
                    locationCart.products.length > 0
                  )
                    return;

                  const sessionId = $target.attr('data-session-id');

                  // $.ajax() already returns a jQuery Deferred (jqXHR), store it directly
                  const jqXhr = $.ajax({
                    type: 'POST',
                    url: '/api/v1/private/sessions/get-action-modal',
                    data: {
                      sessionId,
                      tableId: $target.attr('data-table-id'),
                      hasProductsInCart: locationCart.table_session_id
                        ? 0
                        : products_in_cart,
                    },
                    error: function (data) {
                      if (data.responseJSON?.message) {
                        showToast({
                          type: 'error',
                          message: data.responseJSON.message,
                          position: 'bottom-right',
                          duration: 2000,
                        });
                      }
                    },
                  });

                  $wrap.data('actionModalXhr', jqXhr);
                },

                onComplete: function ($wrap, $target) {
                  if (
                    $target.attr('data-has-enabled-per-person-ordering') ==
                      '1' &&
                    locationCart.products.length > 0
                  ) {
                    const tableId = $target.attr('data-table-id');
                    const tableName = $target.attr('data-table-name');
                    const sessionId = $target.attr('data-session-id');

                    upsertProducts({
                      tableId,
                      sessionId,
                      sourceSessionId: null,
                      products: locationCart.products,
                      orderComment: locationCart.comment,
                      tableName,
                    });
                    return;
                  }

                  const jqXhr = $wrap.data('actionModalXhr');
                  if (!jqXhr) return;

                  // .done()/.fail() on an already-settled jqXHR fires immediately,
                  // on a still-pending one it fires when it eventually settles
                  jqXhr
                    .done(function (response) {
                      const { data } = response;
                      if (data.html == null) return;
                      $('#content-body').append(data.html);

                      if ($('#table-action-modal').length > 0) {
                        $('#table-action-modal')
                          .on('shown.bs.modal', function () {
                            fixBackdrops();
                          })
                          .on('hidden.bs.modal', function () {
                            restoreBackdrops();
                            setTimeout(function () {
                              $('#table-action-modal').remove();
                            }, 500);
                          })
                          .modal('show');
                      }

                      if ($('#table-guest-modal').length > 0) {
                        $('#table-guest-modal')
                          .on('shown.bs.modal', function () {
                            fixBackdrops();
                          })
                          .on('hidden.bs.modal', function () {
                            selectedGuestId = null;
                            restoreBackdrops();
                            setTimeout(function () {
                              $('#table-guest-modal').remove();
                            }, 500);
                          })
                          .modal('show');
                      }
                    })
                    .fail(function (err) {
                      if (err.responseJSON?.redirect_url) {
                        document.location.href = err.responseJSON.redirect_url;
                      }
                    })
                    .always(function () {
                      $wrap.removeData('actionModalXhr');
                    });
                },

                onCancel: function ($wrap, $target) {
                  const jqXhr = $wrap.data('actionModalXhr');
                  if (jqXhr) {
                    jqXhr.abort(); // cancel the in-flight request entirely
                    $wrap.removeData('actionModalXhr');
                  }
                },
              });
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        })
        .always(function () {
          storageModalAjaxLock = false;
        });
    }
  });

  $(document).on('click', '.table-card-content', function () {
    const tableId = $(this).attr('data-table-id');
    const tableName = $(this).attr('data-table-name');
    const sessionId = $(this).attr('data-session-id');
    const sourceSessionId = $(this).attr('data-source-session-id') || null;
    const sessionProductId = $(this).attr('data-session-product-id') || null;
    const hasEnabledPerPersonOrdering =
      $(this).attr('data-has-enabled-per-person-ordering') === '1';
    const hasAlwaysForcedToShowDetails =
      $(this).attr('data-always-show-details') === '1';

    if (sessionProductId) {
      moveSessionProduct({
        sessionProductId,
        targetSessionId: sessionId,
        tableId,
      });
    } else if (sourceSessionId) {
      upsertProducts({
        tableId,
        sessionId,
        sourceSessionId,
        orderComment: locationCart.comment,
        tableName,
      });
    } else if (
      hasEnabledPerPersonOrdering &&
      locationCart.products.length > 0 &&
      !sourceSessionId
    ) {
      setClassicLocationCart({
        ...locationCart,
        products: locationCart.products,
        is_per_person_ordering_enabled: 1,
        table_id: tableId,
        table_session_id: sessionId,
      }).always(function () {
        $('#table-sessions-modal').modal('hide');
      });
    } else if (
      hasAlwaysForcedToShowDetails &&
      sessionId &&
      (locationCart.products.length == 0 ||
        (locationCart.table_session_id &&
          locationCart.table_session_id !== sessionId)) &&
      !sourceSessionId
    ) {
      showTableSessionDetails(sessionId).always(function () {
        ajaxLockForModal = false;
      });
    } else if (
      !locationCart.table_session_id &&
      locationCart.products.length > 0
    ) {
      upsertProducts({
        tableId,
        sessionId,
        sourceSessionId,
        products: locationCart.products,
        orderComment: locationCart.comment,
        tableName,
      });
    } else if (sessionId) {
      getCartData(sessionId)?.always(function () {
        ajaxLockForModal = false;
      });
    }
  });

  $(document).on('submit', '#tempTableSessionForm', function (e) {
    e.preventDefault();

    const tempTableName = $('#tempTableSessionInput').val().trim();

    const submitButton = $('#tempTableSessionAddBtn');
    submitButton.prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/sessions/upsert-temp',
      data: {
        tempTableName,
        products: locationCart.products,
      },
      success: function (response) {
        const totalAmount = locationCart.products.reduce(
          (sum, product) =>
            sum +
            product.original_product_price *
              (1 - product.discount_percent / 100) *
              product.amount,
          0
        );

        showToast({
          type: 'success',
          message: `Sum ${floor(totalAmount)} og ${locationCart.number_of_products} varer satt på ${tempTableName}`,
          position: 'bottom-right',
          duration: 1500,
        });

        $('#table-sessions-modal').modal('hide');
        emptyAllCart();
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }

        if (response.responseJSON?.message) {
          showToast({
            type: 'error',
            message: response.responseJSON.message,
            position: 'bottom-right',
            duration: 2000,
          });
        }
      },
    }).always(function () {
      submitButton.prop('disabled', false);
    });
  });

  $(document).on('click', '#table-action-modal .js-action', function () {
    var action = $(this).data('action');
    var sessionId = $(this).data('session-id');

    $('#table-action-modal .js-action')
      .prop('disabled', true)
      .addClass('disabled');

    switch (action) {
      case 'move':
        showMoveSessionModal(sessionId)?.always(function () {
          $('#table-action-modal .js-action')
            .prop('disabled', false)
            .removeClass('disabled');
          ajaxLockForModal = false;
        });
        break;
      case 'add-name':
        showExtraNameModal(sessionId)?.always(function () {
          $('#table-action-modal .js-action')
            .prop('disabled', false)
            .removeClass('disabled');
          ajaxLockForModal = false;
        });
        break;
      case 'see-details':
        showTableSessionDetails(sessionId)?.always(function () {
          $('#table-action-modal .js-action')
            .prop('disabled', false)
            .removeClass('disabled');
          ajaxLockForModal = false;
        });
        break;
      case 'add-to-cart':
        getCartData(sessionId)?.always(function () {
          $('#table-action-modal .js-action')
            .prop('disabled', false)
            .removeClass('disabled');
          ajaxLockForModal = false;
        });
        $('#table-action-modal').modal('hide');
        break;
      case 'delete':
        deleteSession(sessionId)?.always(function () {
          $('#table-action-modal .js-action')
            .prop('disabled', false)
            .removeClass('disabled');
          ajaxLockForModal = false;
        });
        $('#table-action-modal').modal('hide');
        break;
      case 'print':
        const organizerId = $('body').attr('organizer_id');
        let locationId =
          $('#classic-location-products').attr('data-location-id') ??
          $('#location').attr('data-location-id');

        showPrinterListModal({
          sessionId,
          organizerId,
          locationId,
          printType: 'SESSION_RECEIPT',
        })?.always(function () {
          $('#table-action-modal').modal('hide');
          $('#table-action-modal .js-action')
            .prop('disabled', false)
            .removeClass('disabled');
          ajaxLockForModal = false;
        });
        break;
    }
  });

  $(document).on('click', '.guest-chip', function (e) {
    if (
      $(e.target).hasClass('js-rm-guest') ||
      $(e.target).closest('.js-rm-guest').length
    )
      return;
    const $this = $(this);
    $.ajax({
      type: 'POST',
      url: '/api/v1/private/sessions/set-active-guest',
      data: { guestId: $this.attr('data-guest-id') },
      success: function (response) {
        const { data } = response;

        if (data.activeGuestId !== undefined && data.activeGuestId !== null) {
          activeGuestId = data.activeGuestId;
        }

        if (data.html !== undefined && data.html !== null) {
          $('#product-panels').html(data.html);

          $('.js-split').holdToConfirm({
            totalDuration: 2000,
            holdDelay: 250,
            onComplete: function ($wrap, $target) {
              openSplitPopup(
                $target,
                parseInt($target.data('session-product-id'))
              );
            },
          });
        }

        $('.guest-chip').removeClass('active');
        $this.addClass('active');
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }
      },
    });
  });

  $(document).on('click', '.js-rm-guest', function (e) {
    e.stopPropagation();
    const guestId = $(this).attr('data-guest-id');
    $.ajax({
      type: 'POST',
      url: '/api/v1/private/table-guests/delete',
      data: { guestId },
      success: function (response) {
        const { data, message } = response;
        if (data.html !== undefined && data.html !== null) {
          $('#session-details-body').html(data.html);
          if (data.activeGuestId !== undefined && data.activeGuestId !== null) {
            activeGuestId = data.activeGuestId;
          }

          $('.js-split').holdToConfirm({
            totalDuration: 2000,
            holdDelay: 250,
            onComplete: function ($wrap, $target) {
              openSplitPopup(
                $target,
                parseInt($target.data('session-product-id'))
              );
            },
          });

          updateCanRemoveGuestState();

          showToast({
            type: 'success',
            message: message || 'Gjest fjernet',
            position: 'bottom-right',
            duration: 1500,
          });
        }
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }

        if (response.responseJSON?.message) {
          showToast({
            type: 'error',
            message:
              response.responseJSON.message ||
              'Kunne ikke fjerne gjest, prøv igjen senere',
          });
        }
      },
    });
    // removeGuest($(this).data('gid'));
  });

  $(document).on('click', '.js-split', function (e) {
    e.stopPropagation();
    const sessionProductId = $(this).data('session-product-id');
    if (!sessionProductId) return;

    if ($('.guest-chip').length <= 1) {
      showToast({
        type: 'error',
        message: 'Må være minst 2 gjester for å dele en vare',
        duration: 1500,
      });
    }

    splitProduct({
      sessionProductId,
      splitQuantity: 0,
      sessionId: activeSessionId,
      guestId: activeGuestId,
    });
  });

  $(document).on('click', '.js-item-delete', function (e) {
    e.preventDefault();
    const sessionProductId = $(this).attr('data-session-product-id');
    const $this = $(this);

    if (sessionProductId) {
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/session-products/void',
        data: { sessionProductId },
        success: function (response) {
          const { data, message } = response;
          if (data.success === true) {
            $this.closest('.item-row').fadeOut(function () {
              $(this).remove();
            });
            showToast({
              type: 'success',
              message: message || 'Produkt annullert.',
              position: 'bottom-right',
              duration: 1500,
            });
          }
        },
        error: function (response) {
          if (response.responseJSON?.redirect_url) {
            document.location.href = response.responseJSON.redirect_url;
          }

          if (response.responseJSON?.message) {
            showToast({
              type: 'error',
              message: response.responseJSON.message,
              position: 'bottom-right',
              duration: 2000,
            });
          }
        },
      });
    }
  });

  $(document).on('click', '.js-item-move', function (e) {
    e.preventDefault();
    const sessionProductId = $(this).attr('data-session-product-id');
    if (!sessionProductId) return;

    showMoveSessionModal(activeSessionId, sessionProductId);
  });

  $(document).on('click', '#ssConfirm', function () {
    const sessionProductId = splitState.sessionProductId;
    if (!sessionProductId) return;
    const quantity = splitState.qty;

    splitProduct({
      sessionProductId,
      splitQuantity: quantity,
      sessionId: activeSessionId,
      guestId: activeGuestId,
    });
  });

  $(document).on('click', '#ssMinus', function () {
    if (splitState.qty > 2) {
      splitState.qty--;
      updateSplitPopup();
    }
  });
  $(document).on('click', '#ssPlus', function () {
    if (splitState.qty < 10) {
      splitState.qty++;
      updateSplitPopup();
    }
  });

  $(document).on('click', '.js-assign-one', function () {
    if (!activeGuestId) {
      showToast({
        type: 'error',
        message: 'Velg en gjest først',
        position: 'bottom-right',
        duration: 2000,
      });
    }

    const sessionProductId = $(this).attr('data-session-product-id');

    $.ajax({
      type: 'POST',
      url:
        '/api/v1/private/session-products/' + sessionProductId + '/assign-one',
      data: { guestId: activeGuestId },
      success: function (response) {
        const { data } = response;

        if (data.html !== undefined && data.html !== null) {
          $('#product-panels').html(data.html);

          showToast({
            type: 'success',
            message: data.message || '1 enhet lagt til',
            position: 'bottom-right',
            duration: 1500,
          });

          $('.js-split').holdToConfirm({
            totalDuration: 2000,
            holdDelay: 250,
            onComplete: function ($wrap, $target) {
              openSplitPopup(
                $target,
                parseInt($target.data('session-product-id'))
              );
            },
          });

          if (
            data.modeTabsDisabled !== undefined &&
            data.modeTabsDisabled !== null
          ) {
            $('.mode-tab').prop('disabled', data.modeTabsDisabled);
          }
        }
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }

        if (response.responseJSON?.message) {
          showToast({
            type: 'error',
            message: response.responseJSON.message,
            position: 'bottom-right',
            duration: 2000,
          });
        }
      },
    });
  });

  $(document).on('click', '.js-merge', function () {
    const productAssignmentId = $(this).data('product-assignment-id');

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/session-products/merge-split',
      data: {
        productAssignmentId,
        sessionId: activeSessionId,
        guestId: activeGuestId,
      },
      success: function (response) {
        const { data, message } = response;

        if (data.html !== undefined && data.html !== null) {
          $('#product-panels').html(data.html);

          $('.js-split').holdToConfirm({
            totalDuration: 2000,
            holdDelay: 250,
            onComplete: function ($wrap, $target) {
              openSplitPopup(
                $target,
                parseInt($target.data('session-product-id'))
              );
            },
          });
        }
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }

        if (response.responseJSON?.message) {
          showToast({
            type: 'error',
            message: response.responseJSON.message,
            position: 'bottom-right',
            duration: 1500,
          });
        }
      },
    });
  });

  $(document).on('click', '.js-assign-all', function () {
    if (!activeGuestId) {
      showToast({
        type: 'error',
        message: 'Velg en gjest først',
        position: 'bottom-right',
        duration: 2000,
      });
    }

    const sessionProductId = $(this).attr('data-session-product-id');

    $.ajax({
      type: 'POST',
      url:
        '/api/v1/private/session-products/' + sessionProductId + '/assign-all',
      data: { guestId: activeGuestId },
      success: function (response) {
        const { data, message } = response;

        if (data.html !== undefined && data.html !== null) {
          $('#product-panels').html(data.html);

          showToast({
            type: 'success',
            message: message || 'Alle enheter lagt til',
            position: 'bottom-right',
            duration: 1500,
          });

          $('.js-split').holdToConfirm({
            totalDuration: 2000,
            holdDelay: 250,
            onComplete: function ($wrap, $target) {
              openSplitPopup(
                $target,
                parseInt($target.data('session-product-id'))
              );
            },
          });

          if (
            data.modeTabsDisabled !== undefined &&
            data.modeTabsDisabled !== null
          ) {
            $('.mode-tab').prop('disabled', data.modeTabsDisabled);
          }
        }
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }

        if (response.responseJSON?.message) {
          showToast({
            type: 'error',
            message: response.responseJSON.message,
            position: 'bottom-right',
            duration: 2000,
          });
        }
      },
    });
  });

  $(document).on('click', '.js-assign-split', function () {
    if (!activeGuestId) {
      showToast({
        type: 'error',
        message: 'Velg en gjest først',
        position: 'bottom-right',
        duration: 2000,
      });
    }

    const productAssignmentId = $(this).attr('data-product-assignment-id');

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/session-products/assign-split',
      data: { guestId: activeGuestId, productAssignmentId },
      success: function (response) {
        const { data, message } = response;

        if (data.html !== undefined && data.html !== null) {
          $('#product-panels').html(data.html);

          showToast({
            type: 'success',
            message: message || 'Alle enheter lagt til',
            position: 'bottom-right',
            duration: 1500,
          });

          $('.js-split').holdToConfirm({
            totalDuration: 2000,
            holdDelay: 250,
            onComplete: function ($wrap, $target) {
              openSplitPopup(
                $target,
                parseInt($target.data('session-product-id'))
              );
            },
          });

          if (
            data.modeTabsDisabled !== undefined &&
            data.modeTabsDisabled !== null
          ) {
            $('.mode-tab').prop('disabled', data.modeTabsDisabled);
          }
        }
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }

        if (response.responseJSON?.message) {
          showToast({
            type: 'error',
            message: response.responseJSON.message,
            position: 'bottom-right',
            duration: 2000,
          });
        }
      },
    });
  });

  $(document).on('click', '.js-remove', function () {
    if (!activeGuestId) {
      showToast({
        type: 'error',
        message: 'Velg en gjest først',
        position: 'bottom-right',
        duration: 2000,
      });
      return;
    }
    const productAssignmentId = $(this).data('product-assignment-id');
    const sessionProductId = $(this).data('session-product-id');
    const sessionId = $(this).data('session-id');

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/session-products/unassign-product',
      data: {
        productAssignmentId,
        sessionProductId,
        guestId: activeGuestId,
        sessionId,
      },
      success: function (response) {
        const { data, message, status } = response;
        if (data.html !== undefined && data.html !== null) {
          $('#product-panels').html(data.html);

          showToast({
            type: 'success',
            message: message || 'Produkt fjernet',
            position: 'bottom-right',
            duration: 1500,
          });

          $('.js-split').holdToConfirm({
            totalDuration: 2000,
            holdDelay: 250,
            onComplete: function ($wrap, $target) {
              openSplitPopup(
                $target,
                parseInt($target.data('session-product-id'))
              );
            },
          });

          if (
            data.modeTabsDisabled !== undefined &&
            data.modeTabsDisabled !== null
          ) {
            $('.mode-tab').prop('disabled', data.modeTabsDisabled);
          }
        }
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }

        if (response.responseJSON?.message) {
          showToast({
            type: 'error',
            message: response.responseJSON.message,
            position: 'bottom-right',
            duration: 2000,
          });
        }
      },
    });
  });

  $(document).on('click', '.js-checkout', function () {
    const $button = $(this);
    $button.prop('disabled', true);
    const guestId = $button.attr('data-guest-id') || null;
    const shareAmount = $('#amountInput').val() || null;
    getCartData(activeSessionId, guestId, shareAmount)?.always(function () {
      $button.prop('disabled', false);
    });
  });

  $(document).on('click', '#btnSyncState', function () {
    $.ajax({
      type: 'POST',
      url: '/api/v1/private/sessions/sync-session-state',
      data: { sessionId: activeSessionId },
      success: function (response) {
        const { data, message, status } = response;
        if (data.html !== undefined && data.html !== null) {
          $('#session-details-body').html(data.html);

          $('.js-split').holdToConfirm({
            totalDuration: 2000,
            holdDelay: 250,
            onComplete: function ($wrap, $target) {
              openSplitPopup(
                $target,
                parseInt($target.data('session-product-id'))
              );
            },
          });

          $('#btnSyncState.d-flex').removeClass('d-flex').addClass('d-none');
        }
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }

        if (response.responseJSON?.message) {
          showToast({
            type: 'error',
            message: response.responseJSON.message,
            position: 'bottom-right',
            duration: 2000,
          });
        }
      },
    });
  });

  $(document).on('input', '#amountInput', function () {
    if (!activeGuestId) return;
    const customAmount = $(this).val();
    const maxAvail = $(this).attr('data-max-avail') || 0;
    const cur = parseFloat(customAmount) || 0;
    const remaining = maxAvail - cur;
    const isOver = cur > maxAvail;
    const isOk = !isOver && Math.abs(remaining) < 0.01;

    $(this).toggleClass('over', isOver);
    const textContent =
      (isOver ? '−' + fmt(Math.abs(remaining)) : fmt(Math.max(0, remaining))) +
      ' kr';
    $('.as-val.warn, .as-val.ok, .as-val.danger')
      .removeClass('warn ok danger')
      .addClass(isOver ? 'danger' : isOk ? 'ok' : 'warn')
      .html(textContent);
    $('.btn-ph-checkout').prop('disabled', cur <= 0);
  });

  $(document).on('click', '.js-quick', function () {
    if (!activeGuestId) return;
    const customAmount = String($(this).data('amount'));
    $('#amountInput').val(customAmount).trigger('input');
  });

  $(document).on('click', '.mode-tab', function (e) {
    e.stopPropagation();
    activeMode = $(this).data('mode');
    const $this = $(this);
    $.ajax({
      type: 'POST',
      url: '/api/v1/private/sessions/switch-mode',
      data: {
        mode: activeMode,
        sessionId: activeSessionId,
        guestId: activeGuestId,
      },
      success: function (response) {
        const { data, message, status } = response;
        if (data.html !== undefined && data.html !== null) {
          $('#product-panels').html(data.html);
          $('.mode-tab').removeClass('active');
          $this.addClass('active');

          $('.js-split').holdToConfirm({
            totalDuration: 2000,
            holdDelay: 250,
            onComplete: function ($wrap, $target) {
              openSplitPopup(
                $target,
                parseInt($target.data('session-product-id'))
              );
            },
          });
        }
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }
      },
    });
  });

  $(document).on('click', '#extraNameSaveBtn', function () {
    const customName = $('#sessionExtraNameInput').val().trim();
    const sessionId = $('#sessionExtraNameInput').attr('data-session-id');

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/sessions/set-extra-name',
      data: {
        sessionId,
        extraName: customName,
      },
      success: function (response) {
        const { data } = response;
        if (data.extraName !== undefined && data.extraName !== null) {
          $('#extra-name-modal').modal('hide');
        }
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }

        if (response.responseJSON?.message) {
          showToast({
            type: 'error',
            message: response.responseJSON.message,
            position: 'bottom-right',
            duration: 2000,
          });
        }
      },
    });
  });

  $(document).on('click', '.js-gl-select-guest', function () {
    const guestId = $(this).attr('data-guest-id');
    $('.check-icon-container').addClass('d-none');
    if (selectedGuestId === guestId) {
      selectedGuestId = null;
      $(this).removeClass('selected');
      $('#check-icon-' + guestId).addClass('d-none');
    } else {
      selectedGuestId = guestId;
      $('.js-gl-select-guest').removeClass('selected');
      $(this).addClass('selected');
      $('#check-icon-' + guestId).removeClass('d-none');
    }
  });

  $(document).on('click', '#add-new-guest', function () {
    const sessionId = $(this).attr('data-session-id');
    if (!sessionId) {
      showToast({
        type: 'error',
        message: 'Denne bordøkten er lukket.',
        position: 'bottom-right',
        duration: 2000,
      });
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/table-guests/add',
      data: { session_id: sessionId, isPreAssignChip: 1 },
      success: function (response) {
        const { data } = response;
        if (data.html !== undefined && data.html !== null) {
          $('#add-new-guest').before(data.html);
        }
      },
      error: function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
      },
    });
  });

  $(document).on('click', '#guestSaveBtn', function () {
    if (!selectedGuestId) {
      $('#table-guest-modal').modal('hide');
      return;
    }

    if (locationCart.is_per_person_ordering_enabled) {
      delete locationCart.is_new_guest;
      $('#table-guest-modal')
        .on('hidden.bs.modal', function () {
          setTimeout(function () {
            $('#table-guest-modal').remove();
          }, 500);
        })
        .modal('hide');

      setClassicLocationCart({
        ...locationCart,
        table_guest_id: selectedGuestId,
      });
    } else {
      if (locationCart.products.length === 0) {
        return;
      }

      const $btn = $(this);
      const originalContent = $btn.html();
      const sessionId = $btn.attr('data-session-id');
      const tableId = $btn.attr('data-table-id');
      const tableName = $btn.attr('data-table-name');
      const sourceSessionId = $btn.attr('data-source-session-id') || null;

      $btn
        .prop('disabled', true)
        .html(
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="margin-right: 6px;"></span> Lagrer'
        );

      upsertProducts({
        tableId,
        sessionId,
        sourceSessionId,
        products: locationCart.products,
        orderComment: locationCart.comment,
        guestId: selectedGuestId,
        tableName,
      }).always(function () {
        $('#table-guest-modal').modal('hide');

        // 3. Revert button state after modal fades out
        setTimeout(() => {
          $btn.prop('disabled', false).html(originalContent);
        }, 300);
      });
    }
  });

  $(document).on('click', function (e) {
    const $pop = $('.split-popup');
    if ($pop.length) {
      if (Date.now() - ($pop.data('openedAt') || 0) < 500) return;
      if (!$(e.target).closest('.split-popup, .js-split').length) {
        $pop.remove();
      }
    }
  });

  $(document).on('click', '#btnTableSessionPrint', function () {
    const sessionId = $(this).attr('data-session-id');

    const organizerId = $('body').attr('organizer_id');
    let locationId =
      $('#classic-location-products').attr('data-location-id') ??
      $('#location').attr('data-location-id');

    showPrinterListModal({
      sessionId,
      organizerId,
      locationId,
      printType: 'SESSION_RECEIPT',
    });
  });

  $(document).on('click', '#print-guest-receipt', function () {
    const guestId = $(this).attr('data-guest-id');
    const organizerId = $('body').attr('organizer_id');
    let locationId =
      $('#classic-location-products').attr('data-location-id') ??
      $('#location').attr('data-location-id');

    showPrinterListModal({
      guestId,
      printType: 'GUEST_RECEIPT',
      organizerId,
      locationId,
    });
  });

  $(document).on('click', '.exit-per-person-ordering-btn', function () {
    if (locationCart.products.length > 0) {
      if (
        !confirm(
          'Det er produkter i handlekurven som ikke er lagt til en gjest. Er du sikker på at du vil avslutte?'
        )
      ) {
        return;
      }
    }
    if ($('#table-guest-modal').length) {
      $('#table-guest-modal').remove();
    }
    emptyAllCart();
  });

  $(document).on('click', '.put-on-person-btn', function () {
    const currentGuestId = $(this).attr('data-current-table-guest-id');
    const tableName = $(this).attr('data-table-name');

    if (locationCart.products.length === 0) {
      showToast({
        type: 'error',
        message: 'Det er ingen produkter i handlekurven',
        position: 'bottom-left',
        duration: 2000,
      });

      return;
    }

    const $btn = $(this);
    const sessionId = $(this).attr('data-session-id');
    const tableId = $btn.attr('data-table-id');

    upsertProducts({
      tableId,
      sessionId,
      products: locationCart.products,
      guestId: currentGuestId,
      tableName,
      isPerPersonOrderingEnabled: 1,
    });
  });

  $(document).on('click', '.next-person-btn', function () {
    const sessionId = $(this).attr('data-session-id');
    const currentTableGuestId = $(this).attr('data-current-table-guest-id');
    const nextTableGuestId = $(this).attr('data-next-table-guest-id');

    if (!currentTableGuestId && !nextTableGuestId) {
      showToast({
        type: 'info',
        message:
          'Vennligst legg produktene i handlekurven til en gjest først og trykk "Sett på person" før du går videre til neste person.',
        position: 'bottom-left',
        duration: 2000,
      });
    } else if (nextTableGuestId) {
      setClassicLocationCart({
        ...locationCart,
        table_id: tableId,
        table_session_id: sessionId,
        table_guest_id: nextTableGuestId,
        is_new_guest: 0,
      });
    } else {
      setClassicLocationCart({
        ...locationCart,
        table_id: tableId,
        is_per_person_ordering_enabled: 1,
        number_of_products: 0,
        table_session_id: sessionId,
        is_new_guest: 1,
      });
    }
  });

  $(document).on('click', '.select-person-btn', function () {
    if ($('#table-guest-modal').length) {
      $('#table-guest-modal').modal('show');
    }
  });

  $(document).on(
    'click',
    '.quick-order-payment-container.desktop',
    function (e) {
      if (locationCart.is_per_person_enabled) {
        e.stopPropagation();
        e.preventDefault();
        $('#open-cart').trigger('click');
      }
    }
  );

  showTableSessionDetails = function (sessionId) {
    if (ajaxLockForModal) return;
    ajaxLockForModal = true;

    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/sessions/get-details-modal',
      data: { sessionId },
      success: function (response) {
        const { data, message, status } = response;

        if (data.html == null || data.html == undefined) return;
        $('#content-body').append(data.html);

        if (data.activeGuestId !== undefined && data.activeGuestId !== null) {
          activeGuestId = data.activeGuestId;
        }

        if (data.mode !== undefined && data.mode !== null) {
          activeMode = data.mode;
        }

        if (
          $('#table-action-modal').length &&
          $('#table-sessions-modal').length
        ) {
          // Both modals open — close action first, then sessions, then open details
          $('#table-action-modal')
            .on('hidden.bs.modal', function () {
              $('#table-sessions-modal')
                .on('hidden.bs.modal', function () {
                  openSessionDetailsModal(data);

                  setTimeout(function () {
                    $('#table-sessions-modal').remove();
                  }, 500);
                })
                .modal('hide');

              setTimeout(function () {
                $('#table-action-modal').remove();
              }, 500);
            })
            .modal('hide');
        } else if ($('#table-sessions-modal').length) {
          // Only sessions modal open — close it, then open details
          $('#table-sessions-modal')
            .on('hidden.bs.modal', function () {
              openSessionDetailsModal(data);

              setTimeout(function () {
                $('#table-sessions-modal').remove();
              }, 500);
            })
            .modal('hide');
        } else {
          // No modals open — open details directly
          openSessionDetailsModal(data);
        }
      },

      error: function (data) {
        if (data.responseJSON?.redirect_url) {
          document.location.href = data.responseJSON.redirect_url;
        }
      },
    }).always(function () {
      ajaxLockForModal = false;
    });
  };

  function showMoveSessionModal(sessionId, sessionProductId) {
    if (ajaxLockForModal) return;
    ajaxLockForModal = true;

    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/sessions',
      data: {
        organizer_id: organizerId,
        location_id: locationId,
        sourceSessionId: sessionId,
        sessionProductId: sessionProductId,
      },
      success: function (response) {
        const { data, message, status } = response;
        if (data.html !== undefined && data.html !== null) {
          if ($('#move-table-sessions-modal').length > 0) {
            return;
          }

          $('#content-body').append(data.html);
          $('#move-table-sessions-modal')
            .on('shown.bs.modal', function () {
              fixBackdrops();
            })
            .on('hidden.bs.modal', function () {
              restoreBackdrops();
              setTimeout(function () {
                $('#move-table-sessions-modal').remove();
              }, 500);
            })
            .modal('show');
        }
      },
    }).always(function () {
      ajaxLockForModal = false;
    });
  }

  function showExtraNameModal(sessionId) {
    if (ajaxLockForModal) return;
    ajaxLockForModal = true;

    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/sessions/get-extra-name-modal',
      data: { sessionId },
      success: function (response) {
        const { data, message, status } = response;
        if (data.html !== undefined && data.html !== null) {
          if ($('#extra-name-modal').length > 0) {
            return;
          }

          $('#content-body').append(data.html);
          $('#extra-name-modal')
            .on('shown.bs.modal', function () {
              fixBackdrops();
            })
            .on('hidden.bs.modal', function () {
              restoreBackdrops();
              setTimeout(function () {
                $('#extra-name-modal').remove();
              }, 500);
            })
            .modal('show');
        }
      },
      error: function (data) {
        if (data.responseJSON?.redirect_url) {
          document.location.href = data.responseJSON.redirect_url;
        }
      },
    }).always(function () {
      ajaxLockForModal = false;
    });
  }

  function showPrinterListModal({
    sessionId,
    organizerId,
    locationId,
    printType,
    guestId = null,
  }) {
    if (ajaxLockForModal) return;
    ajaxLockForModal = true;

    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/printer/get-printer-list-modal',
      data: {
        sessionId,
        organizerId,
        locationId,
        printType,
        guestId,
      },
    })
      .done(function (response) {
        const { data } = response;

        if (data.html !== null && data.html !== undefined) {
          if ($('#printer-list-modal').length) {
            $('#printer-list-modal').remove();
          }

          $('#content-body').append(data.html);
          $('#printer-list-modal')
            .on('shown.bs.modal', function () {
              fixBackdrops();
            })
            .on('hidden.bs.modal', function () {
              restoreBackdrops();
              setTimeout(function () {
                $('#printer-list-modal').remove();
              }, 500);
            })
            .modal('show');
        }
      })
      .fail(function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }

        if (data.responseJSON.message) {
          showToast({
            type: 'error',
            message: data.responseJSON.message,
            position: 'bottom-right',
            duration: 2000,
          });
        }
      })
      .always(function () {
        ajaxLockForModal = false;
      });
  }

  function openSessionDetailsModal(data) {
    $('#table-session-details-modal')
      .on('shown.bs.modal', function () {
        activeSessionId = data.activeSessionId || null;
        updateCanRemoveGuestState();
      })
      .on('hidden.bs.modal', function () {
        $('.split-popup').remove();
        activeSessionId = null;
        setTimeout(function () {
          $('#table-session-details-modal').remove();
        }, 500);
      })
      .modal('show');

    $('.js-split').holdToConfirm({
      totalDuration: 2000,
      holdDelay: 250,
      onComplete: function ($wrap, $target) {
        openSplitPopup($target, parseInt($target.data('session-product-id')));
      },
    });
  }

  /* ─────────────────────────────────────────
     SPLIT POPUP (For Hold Confirmation)
    ────────────────────────────────────────── */
  function upsertProducts(payload) {
    const {
      tableId,
      sessionId,
      sourceSessionId,
      products,
      orderComment,
      guestId,
      tableName,
      isPerPersonOrderingEnabled = 0,
    } = payload;

    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/sessions/upsert',
      data: {
        tableId,
        sessionId,
        sourceSessionId,
        products,
        orderComment,
        guestId,
        isPerPersonOrderingEnabled,
      },
      success: function (response) {
        const { data } = response;
        if (data.redirect_url !== undefined && data.redirect_url !== null) {
          document.location.href = data.redirect_url;
        }

        const totalAmount = locationCart.products.reduce(
          (sum, product) =>
            sum +
            product.original_product_price *
              (1 - product.discount_percent / 100) *
              product.amount,
          0
        );

        if (payload.sourceSessionId) {
          showToast({
            type: 'success',
            message: 'Bordet er flyttet!',
            position: 'bottom-right',
            duration: 1500,
          });

          $('#move-table-sessions-modal').modal('hide');
          $('#table-action-modal').modal('hide');
          $('#table-sessions-modal').modal('hide');
        } else if (isPerPersonOrderingEnabled == 0) {
          showToast({
            type: 'success',
            message: `Sum ${floor(totalAmount)} og ${locationCart.number_of_products} varer satt på ${tableName}`,
            position: 'bottom-right',
            duration: 1500,
          });

          $('#table-sessions-modal').modal('hide');
          emptyAllCart();
        } else {
          showToast({
            type: 'success',
            message: `Sum ${floor(totalAmount)} og ${locationCart.number_of_products} varer satt på ${tableName}`,
            position: 'bottom-left',
            duration: 1500,
          });

          if (
            data.assignedGuestId !== undefined &&
            data.assignedGuestId !== null &&
            isPerPersonOrderingEnabled == 1
          ) {
            $('#table-guest-modal').remove();
            setClassicLocationCart({
              ...locationCart,
              products: [],
              number_of_products: 0,
              table_id: tableId,
              table_session_id: data.sessionId ? data.sessionId : sessionId,
              table_guest_id: data.nextGuestId || null,
              is_new_guest: data.nextGuestId ? 0 : 1,
            });
          }
        }
      },
      error: function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
      },
    });
  }

  function moveSessionProduct({ sessionProductId, targetSessionId, tableId }) {
    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/session-products/move',
      data: {
        sessionProductId,
        targetSessionId,
        tableId,
      },
      success: function (response) {
        const { data, message } = response;
        if (data.success == true) {
          $('#move-table-sessions-modal')
            .on('hidden.bs.modal', function () {
              $(
                '.item-row[data-session-product-id="' + sessionProductId + '"]'
              ).fadeOut(300, function () {
                $(this).remove();
              });

              showToast({
                type: 'success',
                message: message || 'Produkt flyttet',
                position: 'bottom-right',
                duration: 1500,
              });

              setTimeout(function () {
                $('#move-table-sessions-modal').remove();
              }, 500);
            })
            .modal('hide');
        }
      },
    });
  }

  function openSplitPopup($btn, sessionProductId) {
    $('.split-popup').remove();
    splitState = { sessionProductId, qty: 2 };
    const item = {
      sessionProductId,
      name: $btn.data('product-name') || 'Produkt',
      qty: $btn.data('quantity') || 2,
      price: $btn.data('total-price') || 0,
    };
    if (!item) return;

    splitState.price = item.price;

    const $pop = $(`
        <div class="split-popup">
          <div class="field-label mb-1">Del vare</div>
          <div class="font-weight-bold text-dark text-truncate mb-3">${item.name}</div>
          <div class="d-flex align-items-center mb-3" style="gap: 12px;">
            <button class="btn step-btn m-0 p-0" id="ssMinus" disabled>&minus;</button>
            <div class="step-num" id="ssNum">2</div>
            <button class="btn step-btn m-0 p-0" id="ssPlus">&plus;</button>
          </div>
          <div class="text-center text-muted mb-3" style="font-size:12px;" id="ssPer">
            <strong class="text-dark">${floor(item.price / 2)
              .toString()
              .replace('.', ',')}</strong> kr per del
          </div>
          <button class="btn btn-split-confirm m-0" id="ssConfirm">
            Del i <span id="ssInLabel">2</span> deler
          </button>
        </div>`);

    // Flag popup birth time so document click doesn't instantly kill it on mouse release
    $pop.data('openedAt', Date.now());
    $('body').append($pop);

    const off = $btn.offset();
    let top = off.top + $btn.outerHeight() + 8;
    let left = off.left;
    const pw = 260;

    if (left + pw > $(window).width() - 16) left = $(window).width() - pw - 16;
    if (top + 220 > $(window).height() - 16) top = off.top - 220 - 8;

    if ($(window).width() < 576) {
      top = '50%';
      left = '50%';
      $pop.css({
        top,
        left,
        transform: 'translate(-50%, -50%)',
        position: 'fixed',
      });
    } else {
      $pop.css({ top, left });
    }
  }

  function splitProduct(data) {
    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/session-products/split',
      data,
      success: function (response) {
        const { data, message } = response;

        if (data.html !== undefined && data.html !== null) {
          $('#product-panels').html(data.html);

          $('.split-popup').remove();

          showToast({
            type: 'success',
            message: message || 'Produkt delt',
            position: 'bottom-right',
            duration: 1500,
          });

          $('.js-split').holdToConfirm({
            totalDuration: 2000,
            holdDelay: 250,
            onComplete: function ($wrap, $target) {
              openSplitPopup(
                $target,
                parseInt($target.data('session-product-id'))
              );
            },
          });
        }
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }

        if (response.responseJSON?.message) {
          showToast({
            type: 'error',
            message: response.responseJSON.message,
            position: 'bottom-right',
            duration: 2000,
          });
        }
      },
    });
  }

  function updateSplitPopup() {
    $('#ssNum').text(splitState.qty);
    $('#ssInLabel').text(splitState.qty);
    $('#ssPer').html(
      `<strong class="text-dark">${floor(splitState.price / splitState.qty)}</strong> kr per del`
    );
    $('#ssMinus').prop('disabled', splitState.qty <= 2);
    $('#ssPlus').prop('disabled', splitState.qty >= 10);
  }

  function getCartData(sessionId, guestId = null, shareAmount = null) {
    if (ajaxLockForModal) return;
    ajaxLockForModal = true;

    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/sessions/get-cart-data',
      data: {
        mode: activeMode,
        guestId,
        sessionId,
        shareAmount,
      },
      success: function (response) {
        const { data } = response;
        if (data.cartProducts !== undefined && data.cartProducts !== null) {
          if (data.cartProducts.length > 0) {
            $('#table-session-details-modal').modal('hide');
            $('#table-sessions-modal').modal('hide');
            setClassicLocationCart({
              ...locationCart,
              products: data.cartProducts,
              number_of_products: data.cartProducts.length,
              checkout_type: 'normal',
              table_session_id: sessionId,
              table_guest_id: guestId || null,
              share_amount: parseFloat(shareAmount) || 0,
            });
          }
        }
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }
      },
    }).always(function () {
      ajaxLockForModal = false;
    });
  }

  function deleteSession(sessionId) {
    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/sessions/delete',
      data: { sessionId },
      success: function (response) {
        const { data, message, status } = response;
        if (data.deleted) {
          showToast({
            type: 'success',
            message: message || 'Sessions slettet',
            position: 'bottom-right',
            duration: 1500,
          });

          const $deletedTableCard = $(
            '.table-card-content[data-session-id="' + sessionId + '"]'
          );
          $deletedTableCard.removeClass('open').attr('data-session-id', '');
          $(".badge-time[data-session-id='" + sessionId + "']").remove();

          $('#table-action-modal').modal('hide');
          $('#table-sessions-modal')
            .on('hidden.bs.modal', function () {
              setTimeout(function () {
                $('#table-sessions-modal').remove();
              }, 500);
            })
            .modal('hide');
        }
      },
      error: function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
        }

        if (response.responseJSON?.message) {
          showToast({
            type: 'error',
            message: response.responseJSON.message,
            position: 'bottom-right',
            duration: 2000,
          });
        }
      },
    });
  }

  function fixBackdrops() {
    // Get all visible modals
    const $visibleModals = $('.modal.show');

    $visibleModals.each(function (index) {
      const $modal = $(this);
      // Base Bootstrap z-index is 1040 for backdrops, 1050 for modals
      // We increase by 20 for each level (10 for backdrop, 10 for modal)
      const zIndexBackdrop = 1040 + index * 20;
      const zIndexModal = 1050 + index * 20;

      $modal.css('z-index', zIndexModal);

      // Find the backdrop associated with this level
      // Bootstrap appends backdrops in order, so we match indices
      const $backdrops = $('.modal-backdrop');
      if ($backdrops.length > index) {
        $($backdrops[index]).css('z-index', zIndexBackdrop);
      }
    });
  }

  function restoreBackdrops() {
    // When a modal is hidden, we wait a tiny bit for the 'show' class
    // to be removed, then re-sync all remaining elements
    setTimeout(() => {
      const $visibleModals = $('.modal.show');
      const $backdrops = $('.modal-backdrop');

      // If no modals left, clean up body classes
      if ($visibleModals.length === 0) {
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open').css('padding-right', '');
        return;
      }

      // Remove the extra backdrop that might have been left behind
      if ($backdrops.length > $visibleModals.length) {
        $backdrops.last().remove();
      }

      // Re-run the alignment logic
      fixBackdrops();

      // Ensure the body keeps the modal-open class if any modal is still visible
      $('body').addClass('modal-open');
    }, 50);
  }
});
